<template>
  <div class="bg-white shadow-md rounded-xl p-4 w-full flex flex-col justify-between">

    <!-- Header Section -->
    <div class="flex justify-between items-center">
      <p class="text-gray-900 font-semibold text-lg">Total Training Hours</p>
      <select v-model="selectedMonth" @change="handleMonthChange"
          class="border border-gray-300 text-gray-700 px-2 py-1 rounded-md focus:outline-none focus:ring focus:border-gray-400 bg-white text-sm">
          <option v-for="month in months" :key="month" :value="month">{{ month }}</option>
        </select>
    </div>

    <div class="flex justify-between items-center">
      <div class="mt-4">
        <p class="text-3xl font-bold text-gray-900">
          {{ hours }}
          <span class="text-green-500 text-sm inline-flex items-center">
            ↑
            {{ percentage }}%
          </span>
        </p>
        <p class="text-gray-400 text-sm mt-1">increased than last week</p>
      </div>

      <!-- Image Instead of Chart -->
      <div class="mt-4 flex justify-end">
        <img src="@/assets/chart-placeholder.png" alt="Consulting Chart" class="w-20 h-auto" />
      </div>
    </div>
  </div>
</template>

<script>
import Api from "../../../router/api"; // Adjust the import path as needed

export default {
  data() {
    return {
      selectedMonth: 'Jan',
      hours: 0,
      percentage: 0,
      months: [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ]
    }
  },
  methods: {
    handleMonthChange() {
      Api.getTotalVisitingHours({ time_period: this.selectedMonth })
        .then(res => {
          this.hours = res.data.total_visiting_hours;
          this.percentage = res.data.increase_percentage || 0;
        })
        .catch(() => {
          this.hours = 0;
          this.percentage = 0;
        });
    }
  },
  mounted() {
    this.handleMonthChange();
  }
}
</script>


// WEBPACK FOOTER //
// src/components/admin/dashboard1/TotalTranningHours.vue